export default "__VITE_ASSET__D9Fa5wKU__"